import type { ProductLogoSmallProps } from "../types";

/**
 * 小サイズのRuleAndPolicyロゴアイコン
 */
export function ProductLogoSmallRuleAndPolicy({
  size = 20,
  color = "#646467",
  ...props
}: ProductLogoSmallProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 21 20"
      fill="none"
      {...props}
    >
      <path
        d="M1.60352 16C1.60352 15.4477 2.05123 15 2.60352 15H4.60352C5.1558 15 5.60352 15.4477 5.60352 16V17C5.60352 17.5523 5.1558 18 4.60352 18H2.60352C2.05123 18 1.60352 17.5523 1.60352 17V16Z"
        fill={color}
      />
      <path
        d="M8.10352 16C8.10352 15.4477 8.55123 15 9.10352 15H11.1035C11.6558 15 12.1035 15.4477 12.1035 16V17C12.1035 17.5523 11.6558 18 11.1035 18H9.10352C8.55123 18 8.10352 17.5523 8.10352 17V16Z"
        fill={color}
      />
      <path
        d="M14.6035 16C14.6035 15.4477 15.0512 15 15.6035 15H17.6035C18.1558 15 18.6035 15.4477 18.6035 16V17C18.6035 17.5523 18.1558 18 17.6035 18H15.6035C15.0512 18 14.6035 17.5523 14.6035 17V16Z"
        fill={color}
      />
      <path
        d="M2.85352 6C2.85352 5.72386 3.07737 5.5 3.35352 5.5H3.85352C4.12966 5.5 4.35352 5.72386 4.35352 6V13.5C4.35352 13.7761 4.12966 14 3.85352 14H3.35352C3.07737 14 2.85352 13.7761 2.85352 13.5V6Z"
        fill={color}
      />
      <path d="M6.85352 5.5V7H3.60352V5.5H6.85352Z" fill={color} />
      <path
        d="M17.3535 6C17.3535 5.72386 17.1297 5.5 16.8535 5.5H16.3535C16.0774 5.5 15.8535 5.72386 15.8535 6V13.5C15.8535 13.7761 16.0774 14 16.3535 14H16.8535C17.1297 14 17.3535 13.7761 17.3535 13.5V6Z"
        fill={color}
      />
      <path
        d="M10.8535 10.0833C10.8535 9.80719 10.6297 9.58333 10.3535 9.58333H9.85352C9.57737 9.58333 9.35352 9.80719 9.35352 10.0833V13.5C9.35352 13.7761 9.57737 14 9.85352 14H10.3535C10.6297 14 10.8535 13.7761 10.8535 13.5V10.0833Z"
        fill={color}
      />
      <path d="M13.3535 5.5V7H16.6035V5.5H13.3535Z" fill={color} />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.1035 1.5C7.61823 1.5 5.60352 3.51472 5.60352 6C5.60352 8.48528 7.61823 10.5 10.1035 10.5C12.5888 10.5 14.6035 8.48528 14.6035 6C14.6035 3.51472 12.5888 1.5 10.1035 1.5ZM12.2559 4.19404C12.1257 4.06386 11.9147 4.06386 11.7845 4.19404L9.37374 6.60478L8.46299 5.69404C8.33282 5.56386 8.12176 5.56386 7.99159 5.69404L7.75588 5.92974C7.62571 6.05991 7.62571 6.27097 7.75588 6.40114L9.13803 7.78329C9.26821 7.91347 9.47926 7.91347 9.60944 7.78329L12.4916 4.90114C12.6218 4.77097 12.6218 4.55991 12.4916 4.42974L12.2559 4.19404Z"
        fill={color}
      />
    </svg>
  );
}
